/**
 * Tournament Constants
 *
 * Centralized constants for tournament-related values including statuses,
 * participant types, difficulty levels, and other enums.
 */

// ============================================================================
// TOURNAMENT STATUS
// ============================================================================

export const TOURNAMENT_STATUS = {
  DRAFT: 'draft',
  REGISTRATION_OPEN: 'registration_open',
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

// ============================================================================
// GAME/MATCH STATUS
// ============================================================================

export const GAME_STATUS = {
  PENDING: 'pending',
  SCHEDULED: 'scheduled',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

// ============================================================================
// CHECK-IN STATUS
// ============================================================================

export const CHECKIN_STATUS = {
  SCHEDULED: 'scheduled',
  CHECKING_IN: 'checking_in',
  READY: 'ready',
  LIVE: 'live',
  COMPLETED: 'completed',
};

// ============================================================================
// PARTICIPANT TYPES
// ============================================================================

export const PARTICIPANT_TYPE = {
  SINGLES: 'singles',
  DOUBLES: 'doubles',
  TEAMS: 'teams',
  SINGLES_DOUBLES: 'singles_doubles',
};

// ============================================================================
// TOURNAMENT FORMATS
// ============================================================================

export const TOURNAMENT_FORMAT = {
  SINGLE_ELIMINATION: 'Single Elimination',
  DOUBLE_ELIMINATION: 'Double Elimination',
  ROUND_ROBIN: 'Round Robin',
  SWISS: 'Swiss',
  LEAGUE: 'League',
};

// ============================================================================
// DIFFICULTY LEVELS
// ============================================================================

export const DIFFICULTY_LEVEL = {
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced',
  PROFESSIONAL: 'Professional',
  ALL_LEVELS: 'All Levels',
};

// ============================================================================
// PARTICIPANT ROLES
// ============================================================================

export const PARTICIPANT_ROLE = {
  ORGANIZER: 'organizer',
  CO_OWNER: 'co-owner',
  PLAYER: 'player',
  COACH: 'coach',
  REFEREE: 'referee',
  SCORER: 'scorer',
  TEAM_OWNER: 'teamOwner',
  PARENTS: 'parents',
};

// ============================================================================
// DEFAULT EXPORT
// ============================================================================

export default {
  TOURNAMENT_STATUS,
  GAME_STATUS,
  CHECKIN_STATUS,
  PARTICIPANT_TYPE,
  TOURNAMENT_FORMAT,
  DIFFICULTY_LEVEL,
  PARTICIPANT_ROLE,
};
